import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import Image from 'next/image';
import { StatusCardStyled } from './StatusCardStyled';
import {getConfigurationActiveValueByName} from '@common/Utility/common-utils';
import {ERX_TIMELINE} from '@common/Utility/constants';
import { IC_STATUS_DELIVERED, IC_STATUS_DELIVERED_PENDING, IC_STATUS_PROCESS, IC_STATUS_PROCESS_PENDING, IC_STATUS_RECIEVED } from '../../Assets/images';

const StatusCard = ({ className, statusData, width = 55, height = 55 }) => {

  const appConfig = useSelector((state) => state?.astercore?.AppConfig?.data?.data);
  const [showTimeline, setShowTimeline] = useState(false);

  useEffect(() => {
    if (appConfig) {
      const showTimelineConfig = getConfigurationActiveValueByName(appConfig, ERX_TIMELINE);
      const parsedConfig = showTimelineConfig ? JSON.parse(showTimelineConfig) : false;
      setShowTimeline(JSON.parse(parsedConfig));
    }
  }, [appConfig]);

  const getStatus = () => {
    if (statusData?.deliveryTitle === 'Received') {
      return (
        <>
        <div className='statusContainer'>
          <div className='statusInner'>
          <Image src={IC_STATUS_RECIEVED} alt="status" width={width} height={height}/>
          <div className='active'>Received</div>
          </div>
          <div className="dottedLine" />
          <div className='statusInner'>
          <Image src={IC_STATUS_PROCESS_PENDING} alt="status" width={width} height={height}/>
          <div className='disabled'>Processing</div>
          </div>
          <div className="dottedLine" />
          <div className='statusInner'>
          <Image src={IC_STATUS_DELIVERED_PENDING} alt="status" width={width} height={height}/>
          <div className='disabled stretched'>Out for delivery</div>
          </div>
        </div>
        {showTimeline && <div className="statusTime">
          <div>{statusData?.formattedDate}</div>
          <div>{statusData?.formattedTime}</div>
          </div>
        }
        {!statusData?.orderNumber && (
        <div className='statusMessage'>
          {statusData?.message}
        </div>
        )}
        </>
      );
    }

    if(statusData?.deliveryTitle === 'Processing') {
      return (
        <>
        <div className='statusContainer'>
          <div className='statusInner'>
          <Image src={IC_STATUS_RECIEVED} alt="status" width={width} height={height}/>
          <div className='active'>Received</div>
          </div>
          <div className="dottedLine" />
          <div className='statusInner'>
          <Image src={IC_STATUS_PROCESS} alt="status" width={width} height={height}/>
          <div className='active'>Processing</div>
          </div>
          <div className="dottedLine" />
          <div className='statusInner'>
          <Image src={IC_STATUS_DELIVERED_PENDING} alt="status" width={width} height={height}/>
          <div className='disabled stretched'>Out for delivery</div>
          </div>
        </div>
        {!statusData?.orderNumber && (
        <div className='statusMessage'>
          {statusData?.message}
        </div>
        )}
        </>
      );
    }

    if(statusData?.deliveryTitle === 'Out for Delivery') {
      return (
        <>
        <div className='statusContainer'>
          <div className='statusInner'>
          <Image src={IC_STATUS_RECIEVED} alt="status" width={width} height={height}/>
          <div className='active'>Received</div>
          </div>
          <div className="dottedLine" />
          <div className='statusInner'>
          <Image src={IC_STATUS_PROCESS} alt="status" width={width} height={height}/>
          <div className='active'>Processing</div>
          </div>
          <div className="dottedLine" />
          <div className='statusInner'>
          <Image src={IC_STATUS_DELIVERED} alt="status" width={width} height={height}/>
          <div className='active stretched'>Out for delivery</div>
          </div>
        </div>
        {!statusData?.orderNumber && (
        <div className='statusMessage'>
          {statusData?.message}
        </div>
        )}
        </>
      );
    }
  };

  return <StatusCardStyled className={className}>
            <div>
              {getStatus()}
            </div>
        </StatusCardStyled>;
};

StatusCard.propTypes = {
  className: PropTypes.string,
  statusData: PropTypes.object,
};

StatusCard.defaultProps = {
  className: '',
  statusData: [],
};

export default StatusCard;
